/* import __COLOCATED_TEMPLATE__ from './redo-button.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type Graph from '../../../models/graph-editor/graph';

interface Args {
  graph: Graph;
}

export default class GraphEditorControlsRedoButtonComponent extends Component<Args> {
  @action redoEdit(): void {
    if (this.args.graph.actionsToRedo.length && !this.args.graph.recordingActions) {
      this.args.graph.redoAction();
    }
  }
}
